'use client';

export interface IndustryFilterProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const industries = [
  { id: 'all', label: 'All Services', icon: '🌐' },
  { id: 'medical', label: 'Medical', icon: '🩺' },
  { id: 'home-services', label: 'Home Services', icon: '🔧' },
  { id: 'legal', label: 'Legal', icon: '⚖️' },
  { id: 'small-business', label: 'Small Business', icon: '🏢' }
];

export default function IndustryFilter({ activeTab, setActiveTab }: IndustryFilterProps) {
  return (
    <div className="flex flex-wrap gap-4 my-12 justify-center">
      {industries.map((ind) => (
        <button
          key={ind.id}
          onClick={() => setActiveTab(ind.id)}
          className={`flex items-center gap-2 px-6 py-3 rounded-full font-bold transition-all border-2 ${
            activeTab === ind.id 
            ? 'bg-brand-red border-brand-red text-white shadow-lg scale-105' 
            : 'bg-white border-gray-200 text-gray-600 hover:border-brand-red'
          }`}
        >
          <span>{ind.icon}</span> {ind.label}
        </button>
      ))}
    </div>
  );
}
